let mainSwiperInstance = null;
let thumbsSwiperInstance = null;
let autoplayButtonInstance = null;
let autoplayClickHandler = null;
let isAutoplayRunning = true;
let resizeTimer = null;
let previousIsSP = null;

const init = () => {
  const sliderEl = document.querySelector('.jsKvSlider');
  if (!sliderEl) return;

  // 既存のインスタンスを破棄
  if (mainSwiperInstance) {
    mainSwiperInstance.destroy(true, true);
    mainSwiperInstance = null;
  }
  if (thumbsSwiperInstance) {
    thumbsSwiperInstance.destroy(true, true);
    thumbsSwiperInstance = null;
  }

  if (autoplayButtonInstance && autoplayClickHandler) {
    autoplayButtonInstance.removeEventListener('click', autoplayClickHandler);
    autoplayClickHandler = null;
  }

  const sliderMain = sliderEl.querySelector('.topKv__slider');
  const sliderThumbs = sliderEl.querySelector('.jsKvSliderNavThumbs');
  const autoplayButton = sliderEl.querySelector('.jsKvSliderNavPlay');
  const navNextButton = sliderEl.querySelector('.jsKvSliderNavNext');
  const navPrevButton = sliderEl.querySelector('.jsKvSliderNavPrev');

  const resetNavButtonState = (button) => {
    if (!button) return;
    button.classList.remove('swiper-button-disabled');
    button.removeAttribute('aria-disabled');
  };

  resetNavButtonState(navNextButton);
  resetNavButtonState(navPrevButton);
  const SwiperClass = window.Swiper || Swiper;

  const TARGET_MIN_SLIDES = 12;
  const AUTOPLAY_DELAY = 4000;

  const storeOriginalSlides = (wrapper) => {
    if (wrapper && !wrapper.dataset.originalSlides) {
      wrapper.dataset.originalSlides = wrapper.innerHTML;
    }
  };

  const resetToOriginalSlides = (wrapper) => {
    if (wrapper && wrapper.dataset.originalSlides) {
      wrapper.innerHTML = wrapper.dataset.originalSlides;
    }
  };

  const ensureMinSlides = (wrapper) => {
    if (!wrapper) return;
    resetToOriginalSlides(wrapper);
    const slides = wrapper.querySelectorAll('.swiper-slide');
    slides.forEach(s => {
      s.classList.remove(
        'swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev',
        'swiper-slide-duplicate', 'swiper-slide-visible', 
        'swiper-slide-duplicate-active', 'swiper-slide-duplicate-next', 'swiper-slide-duplicate-prev'
      );
      s.style.removeProperty('margin-right');
      s.removeAttribute('data-swiper-slide-index');
      s.removeAttribute('style');
    });

    let currentCount = wrapper.querySelectorAll('.swiper-slide').length;
    const originalHTML = wrapper.innerHTML;

    while (currentCount < TARGET_MIN_SLIDES) {
      wrapper.insertAdjacentHTML('beforeend', originalHTML);
      currentCount = wrapper.querySelectorAll('.swiper-slide').length;
    }
  };

  const mainWrapper = sliderMain.querySelector('.swiper-wrapper');
  const thumbWrapper = sliderThumbs.querySelector('.swiper-wrapper');

  const getSlideCount = (wrapper) => wrapper ? wrapper.querySelectorAll('.swiper-slide').length : 0;
  const originalThumbCount = getSlideCount(thumbWrapper);
  const clampThumbsView = (base) => {
    if (!originalThumbCount) return base;
    const effectiveCount = originalThumbCount === 4 ? 3 : originalThumbCount;
    return Math.min(base, effectiveCount);
  };

  // SPかどうかを判定（最初に判定）
  const isSP = window.matchMedia('(max-width: 768px)').matches;
  previousIsSP = isSP;

  if (originalThumbCount > 0) {
    const baseWidth = 1040;
    const baseVw = 74.28;
    const maxSlides = 5;
    let calculatedWidth, calculatedVw;
    
    if (originalThumbCount < maxSlides) {
      const slidesForWidth = originalThumbCount <= 4 ? 3 : originalThumbCount;
      calculatedWidth = baseWidth * slidesForWidth / maxSlides;
      calculatedVw = baseVw * slidesForWidth / maxSlides;
    } else {
      calculatedWidth = baseWidth;
      calculatedVw = baseVw;
    }
    
    sliderThumbs.style.setProperty('--thumbs-btn-width', `${calculatedWidth}px`);
    sliderThumbs.style.setProperty('--thumbs-btn-vw', `${calculatedVw}vw`);
  }

  storeOriginalSlides(mainWrapper);
  storeOriginalSlides(thumbWrapper);

  if (isSP) {
    resetToOriginalSlides(mainWrapper);
    resetToOriginalSlides(thumbWrapper);
  } else {
    if (mainWrapper) ensureMinSlides(mainWrapper);
    if (thumbWrapper) ensureMinSlides(thumbWrapper);
  }

  const LOOP_CONFIG = {
    loop: true,
    loopedSlides: 6,
    loopAdditionalSlides: 2,
  };

  // サムネイルSwiperの設定
  const thumbsSwiperConfig = {
    ...(isSP ? {} : LOOP_CONFIG),
    slidesPerView: clampThumbsView(5),
    spaceBetween: 10,
    centeredSlides: true,
    slideToClickedSlide: true,
    watchSlidesProgress: true,
    threshold: 5,
    preventClicks: false,
    preventClicksPropagation: false,
    breakpoints: {
      0: { 
        slidesPerView: originalThumbCount || 5,
        spaceBetween: 7,
        loop: false,
        allowSlideNext: false,
        allowSlidePrev: false,
        allowTouchMove: false,
        simulateTouch: false,
        centeredSlides: false,
        slideToClickedSlide: false, // SP時は手動で処理
      },
      769: { 
        slidesPerView: clampThumbsView(5),
        spaceBetween: 10,
      },
    },
  };

  thumbsSwiperInstance = new SwiperClass(sliderThumbs, thumbsSwiperConfig);
  const thumbsSwiper = thumbsSwiperInstance;

  // メインSwiperの設定
  const mainSwiperConfig = {
    ...(isSP ? {} : LOOP_CONFIG), // SPの時はループ無効
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 30,
    autoplay: {
      delay: AUTOPLAY_DELAY,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    navigation: {
      nextEl: navNextButton || '.jsKvSliderNavNext',
      prevEl: navPrevButton || '.jsKvSliderNavPrev',
    },
  };

  // PCの時のみcontroller連動を追加
  if (!isSP) {
    mainSwiperConfig.controller = {
      control: thumbsSwiper,
      by: 'slide', 
    };
  }

  mainSwiperInstance = new SwiperClass(sliderMain, mainSwiperConfig);
  const mainSwiper = mainSwiperInstance;

  // SPの時の処理
  if (isSP) {
    // メインスライドの変更時に、サムネイルのアクティブクラスのみ更新（スライドしない）
    const updateThumbActive = () => {
      const activeIndex = mainSwiper.realIndex;
      // すべてのサムネイルからアクティブクラスを削除
      if (thumbsSwiper.slides && thumbsSwiper.slides.length > 0) {
        thumbsSwiper.slides.forEach(slide => {
          slide.classList.remove('swiper-slide-active', 'swiper-slide-thumb-active');
        });
        // 対応するサムネイルにアクティブクラスを追加
        if (thumbsSwiper.slides[activeIndex]) {
          thumbsSwiper.slides[activeIndex].classList.add('swiper-slide-active', 'swiper-slide-thumb-active');
        }
      }
    };
    
    // サムネイルのクリックでメインスライドを変更（イベント委譲を使用）
    const thumbWrapperEl = sliderThumbs.querySelector('.swiper-wrapper');
    if (thumbWrapperEl) {
      thumbWrapperEl.addEventListener('click', (e) => {
        const clickedSlide = e.target.closest('.swiper-slide');
        if (clickedSlide && thumbsSwiper.slides && thumbsSwiper.slides.length > 0) {
          const slideIndex = Array.from(thumbsSwiper.slides).indexOf(clickedSlide);
          if (slideIndex !== -1) {
            // SPの時はループ無効なので、直接slideToを使用
            mainSwiper.slideTo(slideIndex, 300);
          }
        }
      }, { passive: true });
    }
    
    // メインスライドの変更を監視
    mainSwiper.on('slideChange', updateThumbActive);
    mainSwiper.on('slideChangeTransitionEnd', updateThumbActive);
    
    // 初期状態のアクティブクラスを設定（初期化完了を待つ）
    const initThumbActive = () => {
      if (mainSwiper.initialized && thumbsSwiper.initialized) {
        updateThumbActive();
      }
    };
    
    // 両方のSwiperの初期化を待つ
    let mainInit = false;
    let thumbsInit = false;
    
    const checkInit = () => {
      if (mainInit && thumbsInit) {
        initThumbActive();
      }
    };
    
    if (mainSwiper.initialized) {
      mainInit = true;
    } else {
      mainSwiper.on('init', () => {
        mainInit = true;
        checkInit();
      });
    }
    
    if (thumbsSwiper.initialized) {
      thumbsInit = true;
    } else {
      thumbsSwiper.on('init', () => {
        thumbsInit = true;
        checkInit();
      });
    }
    
    // フォールバック
    setTimeout(() => {
      if (mainSwiper.initialized && thumbsSwiper.initialized) {
        initThumbActive();
      }
    }, 200);
  } else {
    // PCの時は通常のcontroller連動
    if (thumbsSwiper.controller) {
      thumbsSwiper.controller.control = mainSwiper;
    }
  }

  const updateAutoplayButton = (playing) => {
    if (!autoplayButtonInstance) return;
    autoplayButtonInstance.classList.toggle('btn--stop', playing);
    autoplayButtonInstance.classList.toggle('btn--play', !playing);
    autoplayButtonInstance.setAttribute(
      'aria-label',
      playing ? '自動再生を停止' : '自動再生を再開'
    );
  };

  autoplayButtonInstance = autoplayButton;

  if (autoplayButtonInstance && mainSwiper.autoplay) {
    const toggleAutoplay = () => {
      if (!mainSwiper.autoplay) return;
      if (isAutoplayRunning) {
        mainSwiper.autoplay.stop();
      } else {
        mainSwiper.autoplay.start();
      }
    };
    autoplayClickHandler = toggleAutoplay;
    autoplayButtonInstance.addEventListener('click', toggleAutoplay);

    mainSwiper.on('autoplayStart', () => {
      isAutoplayRunning = true;
      updateAutoplayButton(true);
    });

    mainSwiper.on('autoplayStop', () => {
      isAutoplayRunning = false;
      updateAutoplayButton(false);
    });

    if (isAutoplayRunning) {
      mainSwiper.autoplay.start();
      updateAutoplayButton(true);
    } else {
      mainSwiper.autoplay.stop();
      updateAutoplayButton(false);
    }
  }
};

const handleResize = () => {
  if (resizeTimer) {
    clearTimeout(resizeTimer);
  }
  resizeTimer = setTimeout(() => {
    const currentIsSP = window.matchMedia('(max-width: 768px)').matches;
    
    // SP/PCの切り替えが発生した場合のみ再初期化
    if (previousIsSP !== null && previousIsSP !== currentIsSP) {
      if (mainSwiperInstance || thumbsSwiperInstance) {
        init();
      }
    }
    previousIsSP = currentIsSP;
  }, 250);
};

document.addEventListener('DOMContentLoaded', init);
window.addEventListener('resize', handleResize);
